import { ToastContainer, toast, Slide } from 'react-toastify'
import styled, { css } from 'styled-components'
import { ifThen } from 'utils/style'
import { Image } from '@quotatisgroup/uikit-public.ui.image'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  ${props => (props.noBackground ? '' : 'background-color: #fff;')}
`

export const Header = styled.div`
  ${({ loaded }) => css`
    ${ifThen(loaded, 'position: fixed', 'position: absolute')};
    left: 0;
    top: 0;
    width: 100%;
    z-index: 20;
  `};
`

export const Content = styled.div`
  width: 100%;
  margin: 0;
`

export const Footer = styled.footer`
  margin-top: auto;
  width: 100%;
`

export const NotificationBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
`

export const IconPart = styled.div`
  align-self: flex-start;
  width: 15%;
  margin: 5px 10px 5px 0;
`

export const TextPart = styled.div`
  align-self: center;
  width: 70%;
`

export const Title = styled.span`
  font-weight: 600;
  color: #222b45;
`

export const Message = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #8f9bb3;
`

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    box-sizing: border-box !important;
    border: 1px solid #e4e9f2 !important;
    border-radius: 4px !important;
    box-shadow: 0 !important;
  }

  .Toastify__close-button {
    flex: 2 !important;
    margin-top: 5px !important;
    align-self: center !important;
  }
`

export const StyledRotateImage = styled(Image)`
  animation: rotate 1.7s linear infinite;
  z-index: 2;

  & .path {
    stroke: hsl(210, 70, 75);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`
